<div
  [ngClass]="frame?.rtlEnabled ? 'controlPanelRtl' : 'controlPanel'"
  fxLayout="row"
  class="responsive-layout"
  [dir]="frame?.rtlEnabled ? 'rtl' : 'auto'"
>
  <div style="padding-top: 5px" fxLayout="row" fxLayoutAlign="start start">
    <table matSort matSortActive="sortOrder" matSortDirection="asc" matSortDisableClear (matSortChange)="sortData()">
      <tr>
        <td class="sortHeader" mat-sort-header="number">{{ res.get('Ticket-List-Number') }}</td>
        <td class="sortHeaderGap"></td>
        <td class="sortHeader" mat-sort-header="designation">{{ res.get('Ticket-List-Designation') }}</td>
        <td class="sortHeaderGap"></td>
        <td class="sortHeader" mat-sort-header="priorityDisplayText">{{ res.get('Ticket-Priority') }}</td>
        <td class="sortHeaderGap"></td>
        <td class="sortHeader" mat-sort-header="street">{{ res.get('Ticket-List-Street') }}</td>
        <td class="sortHeaderGap"></td>
        <td class="sortHeader" mat-sort-header="objectDesignation">{{ res.get('Ticket-List-ObjectDesignation') }}</td>
      </tr>
    </table>
  </div>
  <!-- todo: fix-->
  <div fxLayout="row" fxLayoutAlign="end end">
    <div
      class="mat-chip-width"
      [ngStyle.sm]="{ 'margin-left': 'auto' }"
      [ngStyle.md]="{ 'margin-left': 'auto' }"
      [ngStyle.lg]="{ 'margin-left': 'auto' }"
      [ngStyle.xl]="{ 'margin-left': 'auto' }"
    >
      <mat-chip-listbox>
        @for (filter of dataContext?.dataSource.visibleFilters; track trackById($index, filter)) {
          <mat-chip (removed)="removeFilter(filter)">
            <div style="word-wrap: break-word">
              {{ filter.displayText }}
            </div>
            <mat-icon
              [svgIcon]="res.svgName('Cancel-Image')"
              matChipRemove
              style="width: 25px !important; height: 25px !important"
            ></mat-icon>
          </mat-chip>
        }
      </mat-chip-listbox>
    </div>
    <div
      class="button-group-wrapper"
      [ngStyle.xs]="{ 'margin-left': 'auto' }"
      [ngStyle.sm]="{ 'margin-left': 'auto' }"
      [ngStyle.md]="{ 'margin-left': 'auto' }"
    >
      <dx-button-group
        (onItemClick)="ticketStateFilterClick($event)"
        [(selectedItemKeys)]="selectedTicketStates"
        [id]="'ticketListId'"
        [items]="ticketStateButtons"
        activeStateEnabled="false"
        class="dx-buttongroup-badges"
        focusStateEnabled="false"
        keyExpr="id"
        selectionMode="multiple"
        stylingMode="contained"
      >
        <div *dxTemplate="let button of 'item'">
          <div
            class="button-content"
            [ngClass]="{
              selected: selectedTicketStates.includes(button.id),
              'bell-icon': button.id === 'ReminderFilter',
            }"
          >
            <img [src]="button.icon" alt="{{ button.hint }}" class="button-icon" />
            @if (button.badge !== null && button.badge !== undefined) {
              <span class="badge">{{ button.badge || '0' }}</span>
            }
          </div>
        </div>
      </dx-button-group>
    </div>
  </div>
</div>
<!--normal itemSize="48", but with 60 we enjoy smoother scrolling -->
<cdk-virtual-scroll-viewport
  [dir]="frame?.rtlEnabled ? 'rtl' : 'auto'"
  #ticketListScrollViewPort
  id="ticketListScrollViewPort"
  class="ticketListScrollViewPort consistent-width ticket-list"
  itemSize="66"
  style="overflow-y: auto; width: 100%"
>
  @if (dataContext?.dataSource.data) {
    <div *cdkVirtualFor="let ticket of dataContext?.dataSource.internalDataSource; let tIndex = index">
      <p>
        <mat-card class="ticketPanel" (click)="ticket.ticketTasks?.length > 0 ? navigateToTicketDetail(tIndex) : null">
          <table cellpadding="0" cellspacing="0" class="ticket-list-text">
            <tr style="width: 100%">
              <td [ngStyle]="{ width: frame?.rtlEnabled ? '30px' : '16px' }">
                @if (ticket.stateIconName) {
                  <mat-icon class="TicketStateIcon" [svgIcon]="res.svgName(ticket.stateIconName)"></mat-icon>
                }
              </td>
              <td
                [ngClass]="
                  ticket.ticketTasks?.length > 0 ? 'ticketPanelTicketTitle' : 'ticketPanelTicketTitleWithEmptyTasks'
                "
              >
                <div class="ticket-layout">
                  <span>{{ ticket.toString() }}</span>
                  @if (ticket.hasActiveReminders) {
                    <mat-icon [svgIcon]="res.svgName('Notification-Image')" class="ticketNotification"></mat-icon>
                  }
                </div>
              </td>
            </tr>
          </table>
          <div class="locate-Image-button-container">
            @if (ticket.object?.drawableObjectId || ticket.hasGeometry) {
              <button mat-button (click)="selectTicketInMap(ticket); $event.stopPropagation()">
                <mat-icon class="ticketInMapIcon" [svgIcon]="res.svgName('Locate-Image')"></mat-icon>
              </button>
            }
          </div>
          @for (task of ticket.ticketTasks; track task.id; let i = $index) {
            <div class="ticketPanelTaskTitle">
              @if (task.state === '2') {
                <mat-icon class="ticketPanelTicketTasksIcon" [svgIcon]="res.svgName('Done-Image')"></mat-icon>
              }
              <div fxLayout="row" fxLayoutAlign="start center" style="align-items: center">
                <span>
                  <span [ngClass]="{ ticketTaskText: task.hasActiveReminders }">
                    {{ task.designation }}
                  </span>
                  @if (i < ticket.ticketTasks.length - 1) {
                    ,&nbsp;&nbsp;
                  }
                </span>
              </div>
            </div>
          }
        </mat-card>
      </p>
    </div>
  }
</cdk-virtual-scroll-viewport>
